module.exports = __webpack_public_path__ + "assets/img/coupon-banner.c9bc4d7f.png";